<h1 class="mb-2"><mdb-icon fas icon="cog"></mdb-icon> Roles</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Roles</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div
      class="row filtros-header justify-content-end"
      style="border-bottom: 1px solid #dee2e6"
    >
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="showNewClon(); showModalClonar();"
        mdbWavesEffect
      >
        Clonar rol
      </button>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="showNew(); showModalAgregar();"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 250px">
        <div class="md-form mb-0">
          <input
            value=""
            type="text"
            id="brol"
            class="form-control"
            placeholder="Rol"
            required
            #rol
          />
          <label for="rol">Rol</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <div></div>
    <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Roles</th>
            <th scope="col">Estado</th>
            <th scope="col">Fecha de creación</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!rolList || rolList.length === 0">
            <td colspan="5" style="text-align: center">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let rol of rolList">
            <td>{{ rol.nombre }}</td>
            <td>
              <div *ngIf="rol.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!rol.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>{{ rol.fecha_creacion | date: "dd/MM/yyyy" }}</td>
            <td>
              <button
                class="btn-actions-sm"
                color="info"
                mdbBtn
                type="button"
                size="sm"
                mdbWavesEffect
                data-toggle="modal"
                data-target="#basicExample"
                (click)="showForEdit(rol); showModalModificar()"
                mdbTooltip="Editar"
                placement="right"
              >
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button
                *ngIf="rol.activado"
                class="btn-actions-sm"
                color="primary"
                mdbBtn
                type="button"
                mdbWavesEffect
                (click)="permitirCambioEstado(rol)"
                mdbTooltip="Desactivar"
                placement="right"
              >
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button
                *ngIf="!rol.activado"
                class="btn-actions-sm"
                color="success"
                mdbBtn
                type="button"
                mdbWavesEffect
                (click)="permitirCambioEstado(rol)"
                mdbTooltip="Activar"
                placement="right"
              >
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar rol -->
<div
  style="overflow-y: auto"
  mdbModal
  #agregarRol="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <form
      [formGroup]="formulario"
      (ngSubmit)="insertar(rolOperacionModuloList); agregarRol.hide()"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="agregarRol.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de Rol
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activado"
                    type="checkbox"
                    checked
                  /><span class="lever"></span>Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  formControlName="nombre"
                  value=""
                  type="text"
                  id="arol"
                  class="form-control"
                  placeholder="Rol"
                  required
                  #rol
                  maxlength="30"
                />
                <label for="rol">Rol</label>
                <div
                  *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('required')"
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('maxlength')"
                    >El Nombre no puede superar los 50 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('minlength')"
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="descripcion"
                  value=""
                  type="text"
                  id="adescripcion"
                  class="form-control"
                  placeholder="Descripción"
                  required
                  #descripcion
                  maxlength="50"
                />
                <label for="descripcion">Descripción</label>
                <div
                  *ngIf="
                    formulario.get('descripcion').invalid &&
                    (formulario.get('descripcion').dirty ||
                      formulario.get('descripcion').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('required')"
                    >La Descripción es requerida.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('maxlength')"
                    >La Descripción no puede superar los 50
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('minlength')"
                    >La Descripción debe tener como mínimo 5
                    caracteres.</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="categoria"
                  label="Categoria"
                  [options]="optionsCategoria"
                  [filterEnabled]="true"
                  placeholder="Categoria"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="modulo"
                  label="Módulo"
                  [options]="optionsModulo"
                  [filterEnabled]="true"
                  placeholder="Módulo"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="operacion"
                  label="Operación"
                  [options]="optionsOperacion"
                  placeholder="Operación"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <button
                type="button"
                mdbBtn
                color="info"
                mdbWavesEffect
                (click)="agregarOperacion()"
              >
                Agregar
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Categoria</th>
                  <th scope="col">Módulo</th>
                  <th scope="col">Operación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngIf="
                    !rolOperacionModuloList ||
                    rolOperacionModuloList.length === 0
                  "
                >
                  <td colspan="7" style="text-align: center">
                    Agregué Operacion
                  </td>
                </tr>
                <tr
                  *ngFor="let rol_ope of rolOperacionModuloList; let i = index"
                >
                  <td>{{ rol_ope.categoria_nombre }}</td>
                  <td>{{ rol_ope.modulo_nombre }}</td>
                  <td>{{ rol_ope.operacion_nombre }}</td>
                  <td>
                    <button
                      mdbBtn
                      type="button"
                      size="sm"
                      color="primary"
                      mdbWavesEffect
                      class="btn-actions-sm"
                      mdbTooltip="Eliminar"
                      (click)="eliminarOperacion(i)"
                    >
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="agregarRol.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="submit"
            class="btn btn-secondary waves-light"
            [disabled]="formulario.invalid"
            mdbWavesEffect
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL editarRol -->
<div
  style="overflow-y: auto"
  mdbModal
  #editarRol="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog modal-lg" role="document">
    <form
      [formGroup]="formulario"
      (ngSubmit)="actualizar(rolOperacionModuloList); editarRol.hide()"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="editarRol.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de Rol
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activado"
                    type="checkbox"
                    checked
                  /><span class="lever"></span>Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  formControlName="nombre"
                  value=""
                  type="text"
                  id="erol"
                  class="form-control"
                  placeholder="Rol"
                  required
                  #rol
                  maxlength="30"
                />
                <label for="rol">Rol</label>
                <div
                  *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('required')"
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('maxlength')"
                    >El Nombre no puede superar los 50 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('nombre').hasError('minlength')"
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="descripcion"
                  value=""
                  type="text"
                  id="edescripcion"
                  class="form-control"
                  placeholder="Descripción"
                  required
                  #descripcion
                  maxlength="50"
                />
                <label for="descripcion">Descripción</label>
                <div
                  *ngIf="
                    formulario.get('descripcion').invalid &&
                    (formulario.get('descripcion').dirty ||
                      formulario.get('descripcion').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('required')"
                    >La Descripción es requerida.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('maxlength')"
                    >La Descripción no puede superar los 50
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formulario.get('descripcion').hasError('minlength')"
                    >La Descripción debe tener como mínimo 5
                    caracteres.</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="categoria"
                  label="Categoria"
                  [options]="optionsCategoria"
                  [filterEnabled]="true"
                  placeholder="Categoria"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="modulo"
                  label="Módulo"
                  [options]="optionsModulo"
                  [filterEnabled]="true"
                  placeholder="Módulo"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <mdb-select
                  formControlName="operacion"
                  label="Operación"
                  [options]="optionsOperacion"
                  placeholder="Operación"
                ></mdb-select>
              </div>
            </div>
            <div class="col">
              <button
                type="button"
                mdbBtn
                color="info"
                mdbWavesEffect
                (click)="agregarOperacion()"
              >
                Agregar
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-striped table-hover table-sm align-middle"
            >
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Categoria</th>
                  <th scope="col">Módulo</th>
                  <th scope="col">Operación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngIf="
                    !rolOperacionModuloList ||
                    rolOperacionModuloList.length === 0
                  "
                >
                  <td colspan="7" style="text-align: center">
                    Agregué Operacion
                  </td>
                </tr>
                <tr
                  *ngFor="let rol_ope of rolOperacionModuloList; let i = index"
                >
                  <td>{{ rol_ope.categoria_nombre }}</td>
                  <td>{{ rol_ope.modulo_nombre }}</td>
                  <td>{{ rol_ope.operacion_nombre }}</td>
                  <td>
                    <button
                      mdbBtn
                      type="button"
                      size="sm"
                      color="primary"
                      mdbWavesEffect
                      class="btn-actions-sm"
                      mdbTooltip="Eliminar"
                      (click)="eliminarOperacion(i)"
                    >
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="editarRol.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="submit"
            class="btn btn-secondary waves-light"
            [disabled]="formulario.invalid"
            mdbWavesEffect
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- MODAL clonarRol -->
<div
  style="overflow-y: auto"
  mdbModal
  #clonarRol="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <form
      [formGroup]="formularioClon"
      (ngSubmit)="insertarClon(); clonarRol.hide()"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Clonar Rol
          </h4>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="clonarRol.hide()"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de rol
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label
                  >Inactivo<input
                    formControlName="activado"
                    type="checkbox"
                    checked
                  /><span class="lever"></span> Activo</label
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input
                  formControlName="nombre"
                  value=""
                  type="text"
                  id="crol"
                  class="form-control"
                  placeholder="Rol"
                  required
                  #rol
                  maxlength="30"
                />
                <label for="rol">Rol</label>
                <div
                  *ngIf="
                    formularioClon.get('nombre').invalid &&
                    (formularioClon.get('nombre').dirty ||
                      formularioClon.get('nombre').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formularioClon.get('nombre').hasError('required')"
                    >El Nombre es requerido.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formularioClon.get('nombre').hasError('maxlength')"
                    >El Nombre no puede superar los 50 caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="formularioClon.get('nombre').hasError('minlength')"
                    >El Nombre debe tener como mínimo 5 caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <input
                  formControlName="descripcion"
                  value=""
                  type="text"
                  id="cdescripcion"
                  class="form-control"
                  placeholder="Descripción"
                  required
                  #descripcion
                  maxlength="50"
                />
                <label for="descripcion">Descripción</label>
                <div
                  *ngIf="
                    formularioClon.get('descripcion').invalid &&
                    (formularioClon.get('descripcion').dirty ||
                      formularioClon.get('descripcion').touched)
                  "
                >
                  <mdb-error
                    *ngIf="
                      formularioClon.get('descripcion').hasError('required')
                    "
                    >La Descripción es requerida.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formularioClon.get('descripcion').hasError('maxlength')
                    "
                    >La Descripción no puede superar los 50
                    caracteres.</mdb-error
                  >
                  <mdb-error
                    *ngIf="
                      formularioClon.get('descripcion').hasError('minlength')
                    "
                    >La Descripción debe tener como mínimo 5
                    caracteres.</mdb-error
                  >
                </div>
              </div>
              <div class="md-form">
                <mdb-select
                  formControlName="clonrol"
                  label="Rol a clonar"
                  [options]="optionsClonarRol"
                  placeholder="Roles"
                ></mdb-select>
                <div
                  *ngIf="
                    formularioClon.get('clonrol').invalid &&
                    (formularioClon.get('clonrol').dirty ||
                      formularioClon.get('clonrol').touched)
                  "
                >
                  <mdb-error
                    *ngIf="formularioClon.get('clonrol').hasError('required')"
                    >Por favor seleccione un Rol</mdb-error
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-default waves-light"
            data-dismiss="modal"
            (click)="clonarRol.hide()"
            mdbWavesEffect
          >
            Cerrar
          </button>
          <button
            type="submit"
            class="btn btn-secondary waves-light"
            [disabled]="formularioClon.invalid"
            mdbWavesEffect
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
